/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolSchemaStaticValues,
  ToolSchemaStaticValues$inboundSchema,
} from "./toolschemastaticvalues.js";

export type ListToolSchemaStaticValuesResult = {
  /**
   * Per-tool static values for tools whose input schemas contain at least one matching keyword
   */
  tools: Array<ToolSchemaStaticValues>;
};

/** @internal */
export const ListToolSchemaStaticValuesResult$inboundSchema: z.ZodMiniType<
  ListToolSchemaStaticValuesResult,
  unknown
> = z.object({
  tools: z.array(ToolSchemaStaticValues$inboundSchema),
});

export function listToolSchemaStaticValuesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListToolSchemaStaticValuesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListToolSchemaStaticValuesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListToolSchemaStaticValuesResult' from JSON`,
  );
}
